import { useEffect, useState } from "react";
import axios from "axios";

export default function Forecast({ city }) {
  const [forecast, setForecast] = useState(null);
  const apiKey = "c56dcb7t88aa43c2b2f5cfa690a8917o";

  useEffect(() => {
    const apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${city}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then((response) => {
      setForecast(response.data.daily);
    });
  }, [city]);

  function formatDay(timestamp) {
    const date = new Date(timestamp * 1000);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[date.getDay()];
  }

  if (!forecast) return null;

  return (
    <div className="weather-forecast">
      {forecast.slice(0, 5).map((day, index) => (
        <div className="weather-forecast-day" key={index}>
          <div className="weather-forecast-date">{formatDay(day.time)}</div>
          <img
            src={day.condition.icon_url}
            className="weather-forecast-icon"
            alt=""
          />
          <div className="weather-forecast-temps">
            <span className="weather-forecast-temp">
              <strong>{Math.round(day.temperature.maximum)}º</strong>
            </span>
            <span className="weather-forecast-temp">
              {Math.round(day.temperature.minimum)}º
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
